import React from 'react';
import './MenuButton.css';

interface MenuButtonProps {
  onClick: () => void;
  isOpen: boolean;
}

const MenuButton: React.FC<MenuButtonProps> = React.memo(({ onClick, isOpen }) => {
  return (
    <button
      className={`menu-button ${isOpen ? 'menu-button--open' : ''}`}
      onClick={onClick}
      aria-label="Открыть меню"
      aria-expanded={isOpen}
      type="button"
    >
      <div className="menu-button__icon">
        <span className="menu-button__dot"></span>
        <span className="menu-button__dot"></span>
        <span className="menu-button__dot"></span>
      </div>
    </button>
  );
});

MenuButton.displayName = 'MenuButton';

export default MenuButton;
